<script>
import { reactive } from '@vue/composition-api'

const sponsors = reactive({
  sponsor: {
    name: 'regeneron',
    url: 'https://static.wixstatic.com/media/49e9c5_4a916f0c2762447582fe4cd87bab60ab~mv2.png/v1/fill/w_301,h_35,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/regeneron.png',
    link: 'https://projectboard.world/isef/career-booth-regeneron'
  },
  banner: [
    {
      name: 'blank',
      url: 'https://www.solidbackgrounds.com/images/1024x1024/1024x1024-white-solid-color-background.jpg',
      link: ''
    },
    {
      name: 'regeneron',
      url: 'https://static.wixstatic.com/media/49e9c5_4a916f0c2762447582fe4cd87bab60ab~mv2.png/v1/fill/w_301,h_35,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/regeneron.png',
      link: 'https://projectboard.world/isef/career-booth-regeneron'
    },
    {
      name: 'broadcom',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/broadcom-foundation'
    },
    {
      name: 'johnsonandjohnson',
      url: 'https://static.wixstatic.com/media/49e9c5_b9a4c2c9916e48adbd0b253f7575a932~mv2.png/v1/fill/w_322,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/JJ_Logo_Signature_PMS_Red.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    },
    {
      name: 'test',
      url: 'https://static.wixstatic.com/media/49e9c5_768d9dd4fe0347908c1a654d6b385854~mv2.png/v1/fill/w_255,h_59,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Broadcom_Foundation_Logo_CMYK.png',
      link: 'https://projectboard.world/isef/career-booth-exhibitor/johnson-johnson'
    }
  ]
})

export default {
  data () {
    return {
      sponsors
    }
  },
  computed: {
    isCategories: function () {
      return this.$route.name === 'isefCategories'
    }
  }
}
</script>

<template>
  <div class="isef-sponsor-banner">
    <div class="isef-sponsor-banner-title">
      <span class="isef-sponsor-banner-title-container"
            :class="{'isef-sponsor-banner-title-container-homepage' : !isCategories}">
        <h3 class="isef-sponsor-banner-title-name">
          {{ isCategories ? 'Category Sponsors' : 'Title Sponsor' }}
        </h3>
        <img v-if="!isCategories"
             :src="sponsors.sponsor.url"
             :alt="sponsors.sponsor.name"
             class="isef-sponsor-banner-title-image"/>
      </span>
    </div>
    <div class="isef-sponsor-banner-slider">
      <ul class="isef-sponsor-banner-slider-track">
        <li v-for="sponsor in sponsors.banner"
            :key="sponsor.name"
            class="isef-sponsor-banner-slide"
            :class="{'isef-sponsor-banner-slide-homepage' : !isCategories}">
          <a :href="sponsor.link" target="_blank">
            <img :src="sponsor.url"
                 class="isef-sponsor-banner-slide-image"
                 :alt="sponsor.name" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@mixin white-gradient {
  background: linear-gradient(to right,  rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);
}

$animationSpeed: 40s;

// Animation
@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-250px * 7))}
}
// Sponsor
.isef-sponsor-banner {
  overflow: hidden;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2FVector.png?alt=media&token=b99984c2-1a4f-4551-af8f-c41c83f77a31");
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 10px -5px rgba(0, 0, 0, .125);
  height: 62px;
  padding-top: .75rem;
  z-index: 2;
  @media only screen and (max-width: 900px){
    flex-direction: column !important;
    height: 160px;
    background-repeat: no-repeat;
  }
  @media only screen and (max-width: 600px){
    height: 100px;
    border-radius: 8px;
  }
  &-title {
    @media only screen  and (max-width: 900px){
      padding-bottom: 1rem;
    }
    @media only screen and (max-width: 600px){
      margin-top: .8rem;
      padding-bottom: .1rem;
    }
    &-container {
      margin-top: .5rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @media only screen and (max-width: 900px) {
        align-items: center;
      }
      @media only screen and (max-width: 600px) {
        margin-top: 0;
      }
      height: 100%;
      width: 10rem;
      margin-left: 1rem;
      &-homepage {
        margin-left: 15rem;
        @media only screen and (max-width: 1800px) {
          margin-left: 2rem;
        }
        @media only screen and (max-width: 600px){
          margin-left: 0;
        }
      }
    }
    &-name {
      font-family: 'Trade Gothic Next LT Pro BdCn', sans-serif;
      letter-spacing: 0.01em;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      text-transform: uppercase;
      margin-top: -.3rem;
      padding-bottom: .1rem;
      @media only screen  and (max-width: 900px){
        margin-top: 0;
        font-size: 1em;
        text-align: center;
        padding-bottom: 0;
      }
    }
    &-image {
      width: 120px;
      height: auto;
    }
  }
  // Slider
  &-slider {
    height: 52px;
    margin-left: 2rem;
    overflow:hidden;
    position: relative;
    max-width: 1500px;
    @media only screen and (max-width: 900px){
      height: 62px;
      background-color: #FFFFFF;
    }
    &::before,
    &::after {
      @include white-gradient;
      content: "";
      height: 72px;
      position: absolute;
      width: 200px;
      z-index: 2;
    }
    &::after {
      right: 0;
      top: 0;
      transform: rotateZ(180deg);
    }
    &::before {
      left: 0;
      top: 0;
    }
    &-track {
      animation: scroll $animationSpeed linear infinite;
      display: flex;
      width: calc(250px * 14);
      &:hover {
        animation: scroll $animationSpeed paused linear infinite;
      }
    }
  }
  &-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 2rem;
    height: 100px;
    &-homepage {
      @media only screen and (max-width: 600px) {
        height: 80px;
      }
    }
    width: 250px;
    background-color: white;
    &-image {
      height: auto;
      width: auto;
      margin-bottom: 2rem;
    }
  }
}
</style>
